import React, { useContext } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../../contexts/LocalesContext";
import {
  getOptionsTranslation,
  presetSensibilitaGraficoOptions,
  presetGraficoDiDefaultOptions,
} from "../../utils/miplus";
import { convertValue, getUnit } from "../../utils/unitsConverter";

export default function ConfResumeComponent(props) {
  const { t } = useContext(LocalesContext);
  const isImperial = props.unitsSystem === 'imperial';

  return (
    <div>
      {/* File Management Section */}
      <table className="c-table" style={{ marginBottom: '30px' }}>
        <thead>
            <tr>
                <th>{t("GestioneFile")}</th>
                <th></th>
                <th className="mobile"></th>
            </tr>    
        </thead>
        <tbody>
          <tr>
            <th>{t("NumeroFile")}</th>
            <td>
              {props.configuration.setupFile && (
                <>{props.configuration.setupFile.length || props.numeroFile}</>
              )}
            </td>
            <td className="mobile">
              <span>
                <p>{t("NumeroFile")}</p>
                <p>
                  {props.configuration.setupFile && (
                    <>{props.configuration.setupFile.length || props.numeroFile}</>
                  )}
                </p>
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Configuration Section */}
      <table className="c-table">
        <thead>
            <tr>
                <th>{t("Configurazione")}</th>
                <th></th>
                <th className="mobile"></th>
            </tr>
        </thead>
        <tbody>
          <tr>
            <th>{t("Interfila")}</th>
            <td>
              {convertValue(props.configuration.interfila, 'length', isImperial)} {getUnit('length', isImperial)}
            </td>
            <td className="mobile">
              <span>
                <p>{t("Interfila")}</p>
                <p>{convertValue(props.configuration.interfila, 'length', isImperial)} {getUnit('length', isImperial)}</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("DistanzaSemina")}</th>
            <td>
              {convertValue(props.configuration.distanzaSemina, 'length', isImperial)} {getUnit('length', isImperial)}
            </td>
            <td className="mobile">
              <span>
                <p>{t("DistanzaSemina")}</p>
                <p>{convertValue(props.configuration.distanzaSemina, 'length', isImperial)} {getUnit('length', isImperial)}</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("Investimento")}</th>
            <td>
              {convertValue(props.configuration.investimento, 'investment', isImperial)} {getUnit('investment', isImperial)}
            </td>
            <td className="mobile">
              <span>
                <p>{t("Investimento")}</p>
                <p>{convertValue(props.configuration.investimento, 'investment', isImperial)} {getUnit('investment', isImperial)}</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("NumeroForiDisco")}</th>
            <td>{props.configuration.numeroForiDisco} n°</td>
            <td className="mobile">
              <span>
                <p>{t("NumeroForiDisco")}</p>
                <p>{props.configuration.numeroForiDisco} n°</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("DiametroForiDisco")}</th>
            <td>
              {convertValue(props.configuration.diametroForiDisco / 10, 'height', isImperial)} {getUnit('height', isImperial)}
            </td>
            <td className="mobile">
              <span>
                <p>{t("DiametroForiDisco")}</p>
                <p>{convertValue(props.configuration.diametroForiDisco / 10, 'height', isImperial)} {getUnit('height', isImperial)}</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("GraficoDiDefault")}</th>
            <td>
              {getOptionsTranslation(
                presetGraficoDiDefaultOptions(t),
                props.configuration.graficoDefault
              )}
            </td>
            <td className="mobile">
              <span>
                <p>{t("GraficoDiDefault")}</p>
                <p>
                  {getOptionsTranslation(
                    presetGraficoDiDefaultOptions(t),
                    props.configuration.graficoDefault
                  )}
                </p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("SensibilitaGrafico")}</th>
            <td>
              {getOptionsTranslation(
                presetSensibilitaGraficoOptions(t),
                props.configuration.sensibilitaGrafico
              )}
            </td>
            <td className="mobile">
              <span>
                <p>{t("SensibilitaGrafico")}</p>
                <p>
                  {getOptionsTranslation(
                    presetSensibilitaGraficoOptions(t),
                    props.configuration.sensibilitaGrafico
                  )}
                </p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("SogliaAllarmeQualita")}</th>
            <td>{props.configuration.sogliaAllarmeQualita}%</td>
            <td className="mobile">
              <span>
                <p>{t("SogliaAllarmeQualita")}</p>
                <p>{props.configuration.sogliaAllarmeQualita}%</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("SogliaAllarmePopolazione")}</th>
            <td>{props.configuration.sogliaAllarmePopolazione}%</td>
            <td className="mobile">
              <span>
                <p>{t("SogliaAllarmePopolazione")}</p>
                <p>{props.configuration.sogliaAllarmePopolazione}%</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("LivelloAllarmeGrafico")}</th>
            <td>{props.configuration.livelloAllarmeGrafico}%</td>
            <td className="mobile">
              <span>
                <p>{t("LivelloAllarmeGrafico")}</p>
                <p>{props.configuration.livelloAllarmeGrafico}%</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("LivelloDepressioneMin")}</th>
            <td>
              {convertValue(props.configuration.livelloDepressioneMin, 'pressure', isImperial)} {getUnit('pressure', isImperial)}
            </td>
            <td className="mobile">
              <span>
                <p>{t("LivelloDepressioneMin")}</p>
                <p>{convertValue(props.configuration.livelloDepressioneMin, 'pressure', isImperial)} {getUnit('pressure', isImperial)}</p>
              </span>
            </td>
          </tr>
          <tr>
            <th>{t("LivelloDepressioneMax")}</th>
            <td>
              {convertValue(props.configuration.livelloDepressioneMax, 'pressure', isImperial)} {getUnit('pressure', isImperial)}
            </td>
            <td className="mobile">
              <span>
                <p>{t("LivelloDepressioneMax")}</p>
                <p>{convertValue(props.configuration.livelloDepressioneMax, 'pressure', isImperial)} {getUnit('pressure', isImperial)}</p>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

ConfResumeComponent.propTypes = {
  configuration: PropTypes.object.isRequired,
  numeroFile: PropTypes.number,
  unitsSystem: PropTypes.string,
};

ConfResumeComponent.defaultProps = {
  configuration: {},
  numeroFile: 24,
  unitsSystem: 'metric'
};